import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | HM Services" description="The page you're looking for doesn't exist." path="/404" />
      <section className="flex min-h-[80vh] items-center justify-center bg-navy px-5" data-testid="not-found">
        <div className="text-center">
          <p className="font-serif text-7xl font-bold text-sky">404</p>
          <h1 className="mt-4 font-serif text-3xl text-white">Page not found</h1>
          <p className="mt-3 text-white/70">The page you're looking for doesn't exist or has moved.</p>
          <Button asChild className="mt-8 rounded-full bg-sky px-8 py-6 text-base font-semibold text-navy hover:bg-sky-light">
            <Link to="/">Back to Home</Link>
          </Button>
        </div>
      </section>
    </>
  );
}
